import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "menu-component-line" };
const _hoisted_2 = { class: "text-sm text-gray-800" };
const _hoisted_3 = { class: "font-medium" };
const _hoisted_4 = {
    key: 0,
    class: "text-gray-500"
};
const _hoisted_5 = {
    key: 0,
    class: "mt-1 flex flex-wrap gap-1"
};
const _hoisted_6 = {
    key: 0,
    class: "ml-1 font-medium"
};
const _hoisted_7 = {
    key: 1,
    class: "mt-1 text-xs text-gray-600 italic"
};
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MenuComponentLine',
    props: {
        comp: {}
    },
    setup(__props) {
        const props = __props;
        const hasDetails = computed(() => !!props.comp.selectedMandatoryIngredients?.length ||
            !!props.comp.extras?.length ||
            !!props.comp.removedIngredients?.length);
        const extraPriceCent = (extra) => extra.priceCent != null ? extra.priceCent : Math.round((extra.price || 0) * 100);
        const removedName = (ingredient) => typeof ingredient === 'string' ? ingredient : ingredient.name;
        const formatPrice = (cent) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cent / 100);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("li", _hoisted_1, [
                _createCommentVNode(" Produktname + Größe "),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.comp.productName || 'Komponente'), 1 /* TEXT */),
                    (_ctx.comp.selectedSize)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " · " + _toDisplayString(_ctx.comp.selectedSize.name), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" Details: Pflichtzutaten / Extras / entfernte Zutaten / Anmerkung "),
                (hasDetails.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createCommentVNode(" Pflichtzutaten (ausgewählte Optionen) "),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comp.selectedMandatoryIngredients || [], (group) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                                key: group.groupName
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.selectedIngredients, (ingredient) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                        key: ingredient.ingredientId,
                                        class: "inline-flex items-center bg-blue-100 text-blue-800 px-2 py-0.5 rounded text-xs"
                                    }, " mit " + _toDisplayString(ingredient.name), 1 /* TEXT */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ], 64 /* STABLE_FRAGMENT */));
                        }), 128 /* KEYED_FRAGMENT */)),
                        _createCommentVNode(" Extra-Zutaten (mit Aufpreis) "),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comp.extras || [], (extra) => {
                            return (_openBlock(), _createElementBlock("span", {
                                key: extra.id,
                                class: "inline-flex items-center bg-green-100 text-green-800 px-2 py-0.5 rounded text-xs"
                            }, [
                                _createTextVNode(" + " + _toDisplayString(extra.name) + " ", 1 /* TEXT */),
                                (extraPriceCent(extra) > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (+" + _toDisplayString(formatPrice(extraPriceCent(extra))) + ") ", 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */)),
                        _createCommentVNode(" Entfernte Zutaten "),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comp.removedIngredients || [], (ingredient, i) => {
                            return (_openBlock(), _createElementBlock("span", {
                                key: `rm-${i}`,
                                class: "inline-flex items-center bg-red-100 text-red-800 px-2 py-0.5 rounded text-xs"
                            }, " ohne " + _toDisplayString(removedName(ingredient)), 1 /* TEXT */));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Anmerkung "),
                (_ctx.comp.specialInstructions)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.comp.specialInstructions), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
